import React, { useState } from "react";

const Fornitori = () => {
  const [datiFornitore, setDatiFornitori] = useState({
    ragioneSociale: "",
    nome: "",
    partitaIva: "",
    codiceFiscale: "",
    provincia: "",
    comune: "",
    via_o_piazza: "",
    civico: "",
    cap: "",
    sezioneRui: "",
    codiceRui: "",
    dataIscrizione: "",
    ruolo: "",
  });

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "guests") {
      setDatiFornitori({ ...datiFornitore, [name]: Number(value) });
    } else {
      setDatiFornitori({ ...datiFornitore, [name]: value });
    }
  };

  return (
    <div>
      <div>
        <h3>Modifica fornitore</h3>
      </div>
      <form>
        <div>
          <label>*Ragione Sociale</label>
          <input
            type="text"
            placeholder="Ragione Sociale"
            name="ragioneSociale"
            value={datiFornitore.ragioneSociale}
            onChange={handleChange}
            required
          ></input>
          <label>Nome</label>
          <input
            type="text"
            placeholder="Nome"
            name="nome"
            value={datiFornitore.nome}
            onChange={handleChange}
          ></input>
          <label>*Partita iva</label>
          <input
            type="text"
            placeholder="Partita iva"
            name="partitaIva"
            value={datiFornitore.partitaIva}
            onChange={handleChange}
            required
          ></input>
          <label>Codice Fiscale</label>
          <input
            type="text"
            placeholder="Codice Fiscale"
            name="codiceFiscale"
            value={datiFornitore.codiceFiscale}
            onChange={handleChange}
          ></input>
        </div>
        <div>
          <div>
            <label>*Provincia</label>
            <select
              name="provincia"
              value={datiFornitore.provincia}
              onChange={handleChange}
              required
            >
              <option value="Firenze">Firenze</option>
              <option value="Roma">Roma</option>
              <option value="Napoli">Napoli</option>
            </select>
          </div>
          <div>
            <label>*Comune</label>
            <select
              name="comune"
              value={datiFornitore.comune}
              onChange={handleChange}
              required
            >
              <option value="Firenze">Firenze</option>
              <option value="Roma">Roma</option>
              <option value="Napoli">Napoli</option>
            </select>
          </div>
          <div>
            <label>*Via,Piazza</label>
            <select
              name="via_o_piazza"
              value={datiFornitore.via_o_piazza}
              onChange={handleChange}
              required
            >
              <option value="via franceshini">Via franceshini</option>
              <option value="via Molli">Via Molli</option>
            </select>
          </div>
          <div>
            <label>*Civico</label>
            <input
              type="text"
              placeholder="Civico"
              name="civico"
              onChange={handleChange}
              required
            ></input>
          </div>
          <div>
            <label>*CAP</label>
            <select
              name="cap"
              value={datiFornitore.cap}
              onChange={handleChange}
              required
            >
              <option value="80040">80040</option>
            </select>
          </div>
        </div>
        <div>
          <div>
            <label>*Sezione Rui</label>
            <select
              name="sezioneRui"
              value={datiFornitore.sezioneRui}
              onChange={handleChange}
              required
            >
              <option value="A">A</option>
            </select>
          </div>
          <div>
            <label>*Codice Rui</label>
            <input
              type="text"
              placeholder="Codice Rui"
              name="codiceRui"
              onChange={handleChange}
              required
            ></input>
          </div>
          <div>
            <label>*Data Iscrizione</label>
            <input
              type="date"
              placeholder="Data Iscrizione"
              name="dataIscrizione"
              onChange={handleChange}
              required
            ></input>
          </div>
          <div>
            <label>*Ruolo</label>
            <select
              name="ruolo"
              value={datiFornitore.ruolo}
              onChange={handleChange}
              required
            >
              <option value="Agenzia emittente">Agenzia emitteù</option>
            </select>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Fornitori;
